import { keepPreviousData } from "@tanstack/react-query"
import {
	getUserGetUserBusinessesQueryOptions,
	useUserGetUserBusinesses,
} from "@/shared/api/generated/user/user"
import { GetUserBusinessesResponse } from "@/shared/api/generated/user/user.zod"
import { validateSuccessResponse } from "@/shared/lib/zod-validation-helpers"
import type { QueryHookOptions } from "@/shared/typings"
import { BUSINESSES_ACL_STALE } from "../consts"

export function getUserBusinessesQueryOptions(options?: QueryHookOptions) {
	return getUserGetUserBusinessesQueryOptions({
		query: {
			placeholderData:
				(options?.keepPreviousData ?? true) ? keepPreviousData : undefined,
			enabled: options?.enabled ?? true,
			staleTime: BUSINESSES_ACL_STALE,
			select(data) {
				const result = validateSuccessResponse(GetUserBusinessesResponse, data)
				return result
			},
			refetchOnWindowFocus: true,
			refetchOnReconnect: true,
			refetchOnMount: "always",
		},
	})
}

export function useUserBusinesses(options?: QueryHookOptions) {
	return useUserGetUserBusinesses({
		query: {
			...getUserBusinessesQueryOptions(options),
		},
	})
}
